/* Peptide LP: inline video cards. */
if (!customElements.get('c-pep-video')) {
  customElements.define('c-pep-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.c-pep-video__play');
      if (this.button) this.button.addEventListener('click', () => this.play());
    }
    play() {
      if (!this.video) {
        const tpl = this.querySelector('template');
        if (!tpl) return;
        this.appendChild(tpl.content.cloneNode(true));
        this.video = this.querySelector('video');
      }
      this.classList.add('is-playing');
      document.querySelectorAll('c-pep-video.is-playing').forEach((el) => {
        if (el !== this && el.video) el.video.pause();
      });
      this.video.play().catch(() => {});
      this.video.focus({ preventScroll: true });
    }
  });
}

/* Looping card carousel. */
if (!customElements.get('c-pep-carousel')) {
  customElements.define('c-pep-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.count = Number(this.dataset.count) || 0;
      this.cards = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.loop = this.cards.length > this.count;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(this.loop ? this.count + i : i)));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => this.onSettle(), 120);
      }, { passive: true });
      requestAnimationFrame(() => this.goTo(this.loop ? this.count : 0, 'instant'));
      window.addEventListener('resize', () => this.goTo(this.current ?? (this.loop ? this.count : 0), 'instant'));
    }
    offsetOf(i) {
      const card = this.cards[i];
      const pad = parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
      return card.offsetLeft - this.track.offsetLeft - pad;
    }
    nearest() {
      const x = this.track.scrollLeft;
      let best = 0, dist = Infinity;
      this.cards.forEach((_, i) => { const d = Math.abs(this.offsetOf(i) - x); if (d < dist) { dist = d; best = i; } });
      return best;
    }
    goTo(i, behavior = 'smooth') {
      this.current = i;
      this.track.scrollTo({ left: this.offsetOf(i), behavior });
      this.paint(i);
    }
    step(dir) { this.goTo(this.nearest() + dir); }
    onSettle() {
      let i = this.nearest();
      if (this.loop && (i < this.count || i >= this.count * 2)) {
        i = this.count + (((i - this.count) % this.count) + this.count) % this.count;
        this.goTo(i, 'instant');
        return;
      }
      this.current = i;
      this.paint(i);
    }
    paint(i) {
      const active = this.count ? i % this.count : i;
      this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === active ? 'true' : 'false'));
    }
  });
}

/* Peptide LP header: menu drawer, mobile search row, cart count. */
(function () {
  const header = document.querySelector('[data-pep-header]');
  if (!header) return;
  const drawer = header.querySelector('.c-pep-header__drawer');
  const openBtn = header.querySelector('[data-pep-menu-open]');
  const setMenu = (open) => {
    header.classList.toggle('is-menu-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) drawer.querySelector('a, button')?.focus();
    else openBtn.focus({ preventScroll: true });
  };
  openBtn?.addEventListener('click', () => setMenu(true));
  header.querySelectorAll('[data-pep-menu-close]').forEach((el) => el.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && header.classList.contains('is-menu-open')) setMenu(false); });
  matchMedia('(min-width: 978px)').addEventListener('change', (e) => { if (e.matches && header.classList.contains('is-menu-open')) setMenu(false); });

  const searchBtn = header.querySelector('[data-pep-search-toggle]');
  searchBtn?.addEventListener('click', () => {
    const open = header.classList.toggle('is-search-open');
    searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) header.querySelector('[data-pep-msearch] input')?.focus();
  });

  const count = header.querySelector('[data-pep-cart-count]');
  const refresh = () => fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
    .then((r) => (r.ok ? r.json() : null))
    .then((c) => { if (c && count) count.textContent = c.item_count; })
    .catch(() => {});
  ['cart-drawer:refresh', 'cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach((ev) => document.addEventListener(ev, () => setTimeout(refresh, 300)));
})();
